import React, { useState } from "react"
import { Survey, SurveyData } from "interfaces/dataInterfaces"
import {
  useSaveSurveyMFIFileMutation,
  useSaveSurveyMFIMutation,
  useValidateSurveyMFIMinRequiredFieldsQuery,
  useValidateSurveyMFIQuery,
} from "../../services/mfi/survey"
import { useGetXlsFormQuery } from "../../services/mfi/xlsFormSchemas"
import AddSurvey from "./AddSurvey"

export interface ISurveyMFIData {
  admCode: number | null
  addAdmCode: number | null
  xlsFormId?: number | null
  query: string
  pageNumber: number
  itemList: number
  actionItem: { item: Survey; action: "details" | "delete" } | null
}

const initialState = {
  addAdmCode: null,
  xlsFormId: null,
}

function AddSurveyMFI() {
  const [data, setData] = useState<Partial<ISurveyMFIData>>(initialState)
  const { addAdmCode, xlsFormId } = data

  const [saveCSVFile, { data: csvFile, isLoading: isFileSaving }] = useSaveSurveyMFIFileMutation()
  const { data: validateSurveyRes, isFetching: isValidateFetching } = useValidateSurveyMFIQuery(
    { adm0Code: addAdmCode ?? 0, xlsFormID: xlsFormId ?? 0, fileName: csvFile?.fileName ?? "" },
    { skip: !addAdmCode || !xlsFormId || !csvFile },
  )
  const { data: validateSurveyMin, isFetching: isValidateMinFetching } = useValidateSurveyMFIMinRequiredFieldsQuery(
    { adm0Code: addAdmCode ?? 0, xlsFormID: xlsFormId ?? 0, fileName: csvFile?.fileName ?? "" },
    { skip: !addAdmCode || !xlsFormId || !csvFile || isValidateFetching },
  )
  const [saveSurvey, { isLoading: isSaving, isSuccess, data: surveySaveData }] = useSaveSurveyMFIMutation()

  const { data: xlsForms } = useGetXlsFormQuery(
    { take: 50, skip: 0, adm0Code: addAdmCode ?? 0, search: "" },
    { skip: !addAdmCode },
  )

  const onSaveCSVFile = (dataDownload: FormData) => {
    saveCSVFile(dataDownload)
  }

  const onSaveSurvey = async (dataDownload: SurveyData) => {
    return saveSurvey({ ...dataDownload, surveyOriginalFilename: csvFile?.fileName ?? "" }).unwrap()
  }

  return (
    <AddSurvey
      surveyTypeId={1}
      data={data}
      setData={setData}
      isFileSaving={isFileSaving}
      isValidateFetching={isValidateFetching}
      validateSurveyRes={validateSurveyRes}
      isValidateMinFetching={isValidateMinFetching}
      validateSurveyMin={validateSurveyMin}
      saveCSVFile={onSaveCSVFile}
      saveSurvey={onSaveSurvey}
      isSaving={isSaving}
      isSuccess={isSuccess}
      surveyData={surveySaveData}
      xlsForms={xlsForms}
    />
  )
}

export default AddSurveyMFI
